import axios from '@/libs/api.request'

export const Login = (data) => {
  return axios.request({
    url: '/company/login',
    data,
    method: 'put'
  })
}

export const GetUserInfo = (token) => {
  return axios.request({
    url: '/company/operator',
    method: 'get'
  })
}
export const CompanyRecharge = (data) => {
  return axios.request({
    url: '/company/recharge',
    data,
    method: 'put'
  })
}
export const GetAgent = (data) => {
  return axios.request({
    url: '/company/agent',
    params: data,
    method: 'get'
  })
}
export const GetCode = (data) => {
  return axios.request({
    url: '/company/code',
    params: data,
    method: 'get'
  })
}
export const ReSetPwd = (data) => {
  return axios.request({
    url: '/company/password/reset',
    data,
    method: 'put'
  })
}

export const userCompany = (data) => {
  return axios.request({
    url: '/app/user_company',
    data,
    method: 'post'
  })
}
export const SaveCompany = (data) => {
  return axios.request({
    url: '/company/save',
    data,
    method: 'put'
  })
}
export const SavePassword = (data) => {
  return axios.request({
    url: '/company/password/save',
    data,
    method: 'put'
  })
}
